import { HiSquares2X2 } from 'react-icons/hi2';
import {
    HiCpuChip,
    HiMiniUserGroup,
    HiChartPie,
    HiIdentification,
} from 'react-icons/hi2';

export const getPermissionsData = (t: (key: string) => string) => [
    {
        key: 'Dashboard',
        name: t('pages.role.form.permissions.dashboard'),
        icon: <HiSquares2X2 size={16} />,
        access: 'none',
        children: [],
    },
    {
        key: 'Sims',
        name: t('pages.role.form.permissions.sims'),
        icon: <HiCpuChip size={16} />,
        access: 'none',
        children: [],
    },
    {
        key: 'Plan_Management',
        name: t('pages.role.form.permissions.planManagement'),
        icon: <HiChartPie size={16} />,
        access: 'none',
        children: [
            {
                key: 'Plan_Management.Plans',
                name: t('pages.role.form.permissions.plans'),
                access: 'none',
            },
            {
                key: 'Plan_Management.Zones',
                name: t('pages.role.form.permissions.zones'),
                access: 'none',
            },
        ],
    },
    {
        key: 'SubAccounts',
        name: t('pages.role.form.permissions.subAccounts'),
        icon: <HiIdentification size={16} />,
        access: 'none',
        children: [],
    },
    {
        key: 'Parent-UserManagement',
        name: t('pages.role.form.permissions.userManagement'),
        icon: <HiMiniUserGroup size={16} />,
        access: 'none',
        children: [
            {
                key: 'UserManagement',
                name: t('pages.role.form.permissions.users'),
                access: 'none',
            },
            {
                key: 'RoleManagement',
                name: t('pages.role.form.permissions.roles'),
                access: 'none',
            },
        ],
    },
    {
        key: 'B2CManagement',
        name: t('pages.role.form.permissions.b2cManagement'),
        icon: <HiMiniUserGroup size={16} />,
        access: 'none',
        children: [
            {
                key: 'B2CManagement.Users',
                name: t('pages.role.form.permissions.appUsers'),
                access: 'none',
            },
            {
                key: 'B2CManagement.Packages',
                name: t('pages.role.form.permissions.appPlans'),
                access: 'none',
            },
            {
                key: 'B2CManagement.Discounts',
                name: t('pages.role.form.permissions.discountCodes'),
                access: 'none',
            },
            {
                key: 'B2CManagement.Sales',
                name: t('pages.role.form.permissions.salesReport'),
                access: 'none',
            },
        ],
    },
];
